import { useMemo, useRef } from 'react';
import { isEqual } from 'lodash-es';

/**
 * Hook to deeply memoize any value, especially arrays.
 * @param value
 * @returns
 */
export const useDeepMemoize = <T>(value: T) => {
  const valueRef = useRef<T>();

  const memoizedValue = useMemo(() => {
    if (!value) {
      return value;
    }
    if (!valueRef.current || !isEqual(valueRef.current, value)) {
      valueRef.current = value;
      return value;
    }
    return valueRef.current;
  }, [value]);

  return memoizedValue;
};
